import { WelcomeTitle } from "../../components/glowingtextcomponet/welcometitle.js";

import '../view.css'
import './home.css'

export const Home = () => (
    <div className='view' id="home">

        <WelcomeTitle />

        <p className="texthome">
            Feel free to learn more about me and my projects.
        </p>

    </div>
);
